// require('jquery-bridget');
// $.bridget('Isotope', require('isotope-layout'))
// require('imagesloaded')
//
// var initIsotope = () => {
//     $('.grid').isotope({
//         itemSelector: '.sw-item',
//         masonry: {
//             columnWidth: '.sw-item-size'
//         }
//     })
// }
//
// setTimeout(() => initIsotope(), 300);
// $('.grid').imagesLoaded( function() {
//     initIsotope()
// });




$('.social-title').each(function() {
    var $obj = $(this)
    var $parentObj = $obj.closest('div')
    var $prevObj = $parentObj.prev()
    var treatCol = () => {
        var prevElementOffset = ($prevObj.offset().top - $(window).scrollTop()  - $(window).height() );
        var currentElementOffset = ($parentObj.offset().top - $(window).scrollTop());
        var objX = $obj.offset().left
        var objY = currentElementOffset - $(window).height();
        var objWidth = $prevObj.width();
        var x2test = objY + $obj.height()
        if(x2test < 0 || prevElementOffset > 0) {
            $obj.css('position', 'static');
        } else {
            $obj.css({'position':'fixed','left': objX,'bottom': '0px', 'max-width': objWidth+'px', 'border-top': '1px solid #ddd'});
        }
    }
    treatCol()
    $(window).on('scroll', function() {
        treatCol()
    });
});


// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/socialwall.js